// extracted by mini-css-extract-plugin
export default {"notificationContainer":"Notification_notificationContainer__OgfM4"};